import { defineStore } from 'pinia';
//import i18n from '@/common/i18n';
//import UserRepository from '@/repositories/userRepository';
import cognitoRepository from '@/repositories/common/cognitoRepository';
//import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

export const useUserLoginPasswordUpdateStore = defineStore({
    id: 'userLoginPasswordUpdate',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * cognitoログインAPI
         * @param {*} req
         * @returns response
         */
        async updateNewCognitoPasswordAfterLoginAction(OldPassword, NewPassword) {
            //const cognitoRepository = new CognitoRepository();
            try {
                const response = await cognitoRepository.changeCognitoPasswordByAfterLogin(OldPassword, NewPassword);
                return response;
            } catch (e) {
                return e;
            }
        },
    },
    persist: {},
});
